export const ACCEPTED_ATTACHMENT_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
];

export const ACCEPTED_ATTACHMENT_TYPES_INPUT =
  ACCEPTED_ATTACHMENT_MIME_TYPES.join(',');
